import { DEFAULT_FORMATION, FORMATIONS } from "../constants.js";
import { POSITIONS } from "../types.js";
/**
 * A formação desenhada pelo treinador, vaga a vaga.
 *
 * As outras formações são uma lista de posições com nome; esta leva as vagas
 * na própria tática (`Tactic.custom`), com o ponto do campo onde cada jogador
 * foi posto.
 */
export const CUSTOM_FORMATION = "personalizada";
/**
 * A posição de um ponto do campo.
 *
 * `x` atravessa o campo, de 0 na lateral esquerda a 1 na direita; `y` é a
 * profundidade, de 0 na linha de fundo do ataque a 1 na do nosso gol, a mesma
 * régua com que a tela desenha a escalação. Perto da lateral é jogador de
 * lado (lateral, ponta); no meio, a faixa de profundidade decide entre
 * zagueiro, volante, meio-campo, meia e atacante.
 */
export function positionAt(x, y) {
    const lado = x < 0.25 ? "E" : x > 0.75 ? "D" : null;
    if (y >= 0.6)
        return lado === "E" ? "LE" : lado === "D" ? "LD" : "ZAG";
    if (y >= 0.5)
        return lado === "E" ? "LE" : lado === "D" ? "LD" : "VOL";
    if (y >= 0.38)
        return lado === "E" ? "PE" : lado === "D" ? "PD" : "MC";
    if (y >= 0.25)
        return lado === "E" ? "PE" : lado === "D" ? "PD" : "MEI";
    return lado === "E" ? "PE" : lado === "D" ? "PD" : "ATA";
}
/**
 * As vagas personalizadas servem: onze, o goleiro na primeira e só nela, e
 * cada ponto dentro do campo.
 */
export function validCustomSlots(custom) {
    if (!custom || custom.length !== 11)
        return false;
    return custom.every((slot, index) => POSITIONS.includes(slot.pos) &&
        (index === 0) === (slot.pos === "GOL") &&
        Number.isFinite(slot.x) &&
        Number.isFinite(slot.y) &&
        slot.x >= 0 &&
        slot.x <= 1 &&
        slot.y >= 0 &&
        slot.y <= 1);
}
/**
 * As posições das vagas da tática, na ordem dos titulares.
 *
 * A personalizada traz as dela; as outras vêm da lista, e nome desconhecido
 * cai no 4-4-2, como sempre caiu. Toda leitura de vaga passa por aqui: a
 * partida, a escalação automática e a tela.
 */
export function tacticSlots(tactic) {
    if (tactic.formation === CUSTOM_FORMATION && validCustomSlots(tactic.custom)) {
        return tactic.custom.map((slot) => slot.pos);
    }
    const formation = FORMATIONS[tactic.formation] ?? FORMATIONS[DEFAULT_FORMATION];
    return formation ? [...formation.slots] : [];
}
/**
 * A tática que o motor aceita guardar.
 *
 * Personalizada sem vagas que sirvam volta para a formação padrão, e as vagas
 * só ficam na personalizada: numa formação da lista elas seriam peso morto no
 * save.
 */
export function normalizeTactic(tactic) {
    const { custom, ...rest } = tactic;
    if (tactic.formation !== CUSTOM_FORMATION)
        return rest;
    if (!validCustomSlots(custom))
        return { ...rest, formation: DEFAULT_FORMATION };
    return { ...rest, custom: custom.map((slot) => ({ ...slot })) };
}
//# sourceMappingURL=formation.js.map